// File: frontend/src/pages/InvestorPitch/components/slides/AIImpactCategoriesSlide/AIImpactCategoriesSlide.js

import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { ANIMATION_VARIANTS } from '../../../constants/animations';
import styles from './AIImpactCategoriesSlide.module.css';

const CategoryCard = ({ title, reduction, color, items }) => {
  return (
    <div className={styles.categoryCard} style={{ borderTopColor: color }}>
      <div className={styles.cardHeader}>
        <div className={styles.categoryHeader}>
          <h3 className={styles.categoryTitle}>{title}</h3>
          <div className={styles.categoryReduction}>{reduction}</div>
        </div>
      </div>
      <div className={styles.cardContent}>
        <ul className={styles.categoryList}>
          {items.map((item, itemIndex) => (
            <li key={itemIndex} className={styles.categoryItem}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const AIImpactCategoriesSlide = () => {
  const { t } = useLanguage();

  const categories = [
    {
      id: 'simple',
      title: t('investor_pitch.ai_impact.simple.title', 'Simple Operations'),
      reduction: '99.9%',
      color: 'var(--color-blue-210)',
      items: [
        t('investor_pitch.ai_impact.simple.item1', 'Automated document processing with NLP'),
        t('investor_pitch.ai_impact.simple.item2', 'Robotic Process Automation for repetitive tasks'),
        t('investor_pitch.ai_impact.simple.item3', 'ML models for standard claims triage'),
        t('investor_pitch.ai_impact.simple.item4', 'Automated policy issuance and renewals'),
        t('investor_pitch.ai_impact.simple.item5', 'AI-Agent based workflows')
      ]
    },
    {
      id: 'medium',
      title: t('investor_pitch.ai_impact.medium.title', 'Medium Complexity'),
      reduction: '80%',
      color: 'var(--color-blue-310)',
      items: [
        t('investor_pitch.ai_impact.medium.item1', 'AI-powered underwriting with real-time risk assessment'),
        t('investor_pitch.ai_impact.medium.item2', 'Intelligent support with predictive issue resolution'),
        t('investor_pitch.ai_impact.medium.item3', 'Automated fraud detection and risk scoring'),
        t('investor_pitch.ai_impact.medium.item4', 'Smart workflow optimization and resource allocation')
      ]
    },
    {
      id: 'high',
      title: t('investor_pitch.ai_impact.high.title', 'High Complexity'),
      reduction: '75%',
      color: 'var(--color-blue-410)',
      items: [
        t('investor_pitch.ai_impact.high.item1', 'Advanced predictive modeling for complex risks'),
        t('investor_pitch.ai_impact.high.item2', 'AI-assisted compliance monitoring and reporting'),
        t('investor_pitch.ai_impact.high.item3', 'Automated actuarial calculations and portfolio optimization'),
        t('investor_pitch.ai_impact.high.item4', 'Smart contract analysis and management')
      ]
    },
    {
      id: 'strategic',
      title: t('investor_pitch.ai_impact.strategic.title', 'Strategic Operations'),
      reduction: '50%',
      color: 'var(--color-blue-510)',
      items: [
        t('investor_pitch.ai_impact.strategic.item1', 'AI-driven project management and resource optimization'),
        t('investor_pitch.ai_impact.strategic.item2', 'Automated testing and deployment pipelines'),
        t('investor_pitch.ai_impact.strategic.item3', 'Intelligent system integration and data migration'),
        t('investor_pitch.ai_impact.strategic.item4', 'Predictive maintenance and infrastructure optimization')
      ]
    }
  ];

  return (
    <motion.div
      className={styles.container}
      variants={ANIMATION_VARIANTS.stagger.container}
      initial="hidden"
      animate="visible"
    >
      <motion.div 
        className={styles.header}
        variants={ANIMATION_VARIANTS.fadeIn}
      >
        <h2 className={styles.title}>
          {t('investor_pitch.ai_impact.title', 'AI Impact Categories')}
        </h2>
        {/* <p className={styles.subtitle}>
          {t('investor_pitch.ai_impact.subtitle', 'How our AI solutions transform different operational areas')}
        </p> */}
      </motion.div>

      <motion.div 
        className={styles.categoriesGrid}
        variants={ANIMATION_VARIANTS.stagger.container}
      >
        {categories.map((category, index) => (
          <motion.div
            key={category.id}
            className={styles.categoryCardWrapper}
            variants={ANIMATION_VARIANTS.stagger.item}
            custom={index}
          >
            <CategoryCard 
              title={category.title}
              reduction={category.reduction}
              color={category.color}
              items={category.items}
            />
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default AIImpactCategoriesSlide;